// messageCommentsに関するstore

import axios from "axios";
import store from '../../store'

import consts from '../../utils/consts'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const state = {
  articleComments: [],
  articleCommentsCount: -1,
  articleGoodsCount: -1,
  HTTP_SUCCESS: false,
  articleGood: false,
  displayProgress: false,
  isSendingRequest: false
}


const getters = {
  articleComments: (state) => {
    return state.articleComments
  },
  articleCommentsCount: (state) => {
    return state.articleCommentsCount
  },
  articleGoodsCount: (state) => {
    return state.articleGoodsCount
  },
  httpSuccess: (state) => {
    return state.HTTP_SUCCESS
  },
  articleGood: (state) => {
    return state.articleGood
  },
  displayProgress: (state) => {
    return state.displayProgress
  },
  isSendingRequest: (state) => {
    return state.isSendingRequest
  }
}


const actions = {
  // 記事のコメントを取得
  async getArticleComments ({ commit }, { api_path, p, page, per}) {
    commit('setDisplayProgress', true)
    const apiPath = api_path.replace('###', p)
    await axios.get(apiPath + '?page=' + page + "&per=" + per)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        alert(res.data.message);
        commit('setArticleComments', 0)
        commit('setDisplayProgress', false)
      } else {
        commit('setArticleComments', res.data.data.data)
        commit('setArticleCommentsCount', res.data.data.length)
        commit('setDisplayProgress', false)
      }
    })
  },
  // 記事にコメントを投稿
  async postArticleComments ({ commit }, { api_path, p, payload}) {
    commit('setHttpSuccess', false)
    commit('setIsSendingRequest', true)
    const apiPath = api_path.replace('###', p)
    await axios.post(apiPath, payload)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        commit('setIsSendingRequest', false)
        alert(res.data.message);
        commit('setArticleComments', 0)
      } else {
        commit('setIsSendingRequest', false)
        commit('setArticleComments', res.data.data.data)
        commit('setArticleCommentsCount', res.data.data.length)
        commit('setHttpSuccess', true)
      }
    })
  },
  // 記事にイイねをする
  async postArticleGoods ({ commit }, { api_path, p}) {
    commit('setIsSendingRequest', true)
    const apiPath = api_path.replace('###', p)
    await axios.post(apiPath)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        commit('setIsSendingRequest', false)
        alert(res.data.message);
      } else {
        commit('setIsSendingRequest', false)
        commit('setArticleGoodsCount', res.data.data.good_length)
        commit('setArticleGood', res.data.data.is_gooded)
      }
    })
  },
  // 記事のイイねを取り消す
  async deleteArticleGoods ({ commit }, { api_path, p}) {
    commit('setIsSendingRequest', true)
    const apiPath = api_path.replace('###', p)
    await axios.delete(apiPath)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        commit('setIsSendingRequest', false)
        alert(res.data.message);
      } else {
        commit('setIsSendingRequest', false)
        commit('setArticleGoodsCount', res.data.data.good_length)
        commit('setArticleGood', res.data.data.is_gooded)
      }
    })
  },
}


const mutations = {
  // 記事のコメントを設定する
  setArticleComments (state, comments) {
    state.articleComments = comments
  },
  // 記事のコメント数を設定
  setArticleCommentsCount (state, length) {
    state.articleCommentsCount = length
  },
  // 記事のいいね数を設定
  setArticleGoodsCount (state, length) {
    state.articleGoodsCount = length
  },
  setHttpSuccess (state, payload) {
    state.HTTP_SUCCESS = payload
  },
  setArticleGood (state, payload) {
    state.articleGood = payload
  },
  setDisplayProgress (state, payload) {
    state.displayProgress = payload
  },
  setIsSendingRequest (state, payload) {
    state.isSendingRequest = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
